module.exports = __webpack_public_path__ + "img/category_38.9ed5fad1.png";